import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { ExtendedDatePickerProps } from "@/types/extendedDatePicker";

export default function ExtendedDatePicker({
  isMobileDevice,
  slotProps,
  ...props
}: ExtendedDatePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {!isMobileDevice ? (
        <DesktopDatePicker {...props} slotProps={slotProps} />
      ) : (
        <MobileDatePicker {...props} slotProps={slotProps} />
      )}
    </LocalizationProvider>
  );
}
